<template>
	<div>
		<new-flowr-subscription />
	</div>
</template>

<script>
	import { newFlowrSubscription } from '@/components/ui-facilita/contracts'

	export default {
		components: {
			newFlowrSubscription,
		},

		mounted() {
			this.$root.$emit('modal-open-new-flowr-subscription')
		},
	}
</script>
